import { zodSortField } from "@/lib/utils";
import { z } from "zod";

export const deleteAvsInternalAccountSchema = z.object({
  id: z.number(),
});

export const getAvsInternalAccountsRequestSchema = z.object({
  sort: zodSortField(["label"]),
});

export const addAvsInternalAccountSchema = z.object({
  sellingType: z
    .string()
    .min(1, "Le type de vente est requis")
    .max(20, "Maximum de caractères atteint"),
  label: z
    .string()
    .min(1, "Le libellé est requis")
    .max(50, "Maximum de caractères atteint"),
  brandLetter: z.enum(["A", "V", "N", "S", "C"], {
    message: "La marque est incohérente",
  }),
  accountNumber: z.string().min(8, "Le n° de compte est incohérent"),
  kvps: z
    .string()
    .regex(/^([A-Z]{3})(\d{5}|995)([A,C,N,S,V])$/, "Le kvps est incohérent"),
});

export const editAvsInternalAccountSchema = z.object({
  id: z.number().optional(),
  sellingType: z
    .string()
    .min(1, "Le type de vente est requis")
    .max(20, "Maximum de caractères atteint"),
  label: z
    .string()
    .min(1, "Le libellé est requis")
    .max(50, "Maximum de caractères atteint"),
  brandLetter: z.enum(["A", "V", "N", "S", "C"], {
    message: "La marque est incohérente",
  }),
  accountNumber: z.string().min(8, "Le n° de compte est incohérent"),
  kvps: z
    .string()
    .regex(/^([A-Z]{3})(\d{5}|995)([A,C,N,S,V])$/, "Le kvps est incohérent"),
  isActive: z.boolean().default(true),
});
